export enum TYPE {
  PRODUCT = "product",
  INSECT = "insect",
  PACKAGE = "package",
  TECHNIQUE = "technique",
  SETPOINT_PARAMETERS = "setpoint",
}

export enum ACTION {
  NEW = "NEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
  ENABLE = "ENABLE",
  DISABLE = "DISABLE",
}

export enum MASTER_DIALOG {
  PRODUCT,
  INSECT,
  PACKAGE,
  TECHNIQUE,
  SETPOINT_PARAMETERS,
}
